import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.9142 6.45208L12 1.59375L7.08581 6.45207L8.49191 7.87435L11 5.39477V12.504H13V5.39478L15.5081 7.87435L16.9142 6.45208Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.5 2.00003H2V22H22V2.00003H16.5V4.00003H20V14H4V4.00003H7.5V2.00003ZM8.00195 16.998V19.002H5.99805V16.998H8.00195ZM11.002 16.998V19.002H8.99805V16.998H11.002Z"}}]};

const UninstallFilled = Vue.extend<IconProps>({
  name: 'UninstallFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'uninstall-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default UninstallFilled;
